export const DropdownFilter = ({ label, icon, isOpen, onToggle, children }) => (
    <div className="relative">
      <button
        onClick={onToggle}
        className="flex items-center space-x-2 px-4 py-2 border rounded-lg bg-white shadow-sm hover:bg-gray-100"
      >
        {icon}
        <span>{label}</span>
      </button>
      {isOpen && (
        <div className="absolute mt-2 min-w-[200px] bg-white border rounded-lg shadow-lg p-2 z-[9999]">
          {children}
        </div>
      )}
    </div>
  );
  
export  const DropdownFilterItem = ({ text, onClick }) => (
    <div onClick={onClick} className="px-4 py-2 cursor-pointer text-start hover:bg-gray-100">
      {text}
    </div>
  );